import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import GamePlayer from "../components/GamePlayer";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

export default function GameFullScreen() {
    const { gameId } = useParams();
    const navigate = useNavigate();

    const handleClose = () => {
        navigate("/", { replace: true });
    };

    return (
        <>
            <Box
                sx={{
                    width: "48px",              // changed from 100vw to 100%
                    boxSizing: "border-box",   // include padding within width
                    display: "flex",
                    justifyContent: "flex-end",
                    bgcolor: "background.paper",
                    boxShadow: 1,
                    zIndex: 1,
                    borderRadius:10,
                    position:"absolute",
                    top:"20px"
                }}
            >
                <IconButton onClick={handleClose} aria-label="Close game" size="large">
                    <CloseIcon />
                </IconButton>
            </Box>
            <GamePlayer gameId={gameId} onClose={handleClose} />
        </>
    )
}